import { CardLabelProps } from '@design-system/card';

import { Category } from '~/types/common';

export const getCardsCategoriesLabels = (
  categoriesArr: Category[] | undefined
): CardLabelProps[] | [] =>
  Array.isArray(categoriesArr) && categoriesArr.length > 0
    ? categoriesArr
        .filter((item) => item.use_in_lables)
        .map(
          (item): CardLabelProps => ({
            labelContent: item.title,
            srOnlyLabelPrefix: '',
            labelVariant: 'secondary',
            labelSize: 'large',
          })
        )
    : [];
